import DETAILS from "@constants/shopDetails";
import WebPaths from "@router/paths/web";

import "./style.scss";

const Copyright = () => {
    return (
        <div className=" copyright">
            <div className="copyrightItems container-costumer">
                <div>
                    <i className="fa fa-copyright"/>
                    {new Date().getFullYear() + ' - تمام حقوق این وبسایت متعلق به '}
                    <span>
                    <a href={WebPaths.home} target="_blank" rel="noreferrer">
                       {DETAILS.name}
                    </a>
                </span>
                    {' میباشد.'}
                </div>
                <div className="font-small-3">
                    {'این وبسایت توسط '}
                    <span>
                    <a href={DETAILS.developmentCompanyWebsite.link} target="_blank" rel="noreferrer">
                       {DETAILS.developmentCompanyWebsite.name}
                    </a>
                </span>
                    {' طراحی و تولید شده است.'}
                </div>
            </div>
        </div>
    );
};

export default Copyright;